import { menuItems } from '../constants/nav-routing';
import { formatDate } from './dateHelpers';
import preval from 'preval.macro';

export const inputValidation = (value) => {
  const regixAlphanumericNdash = /^[0-9a-zA-Z\-_ !&#]+$/;
  if (!value || !value.match(regixAlphanumericNdash)) {
    return false;
  }
  return true;
};

export function checkForAlphabeticChars(text: string) {
  return text.match(/^[a-zA-Z0-9\s]+$/);
}

export function replaceSpecialChars(text: string) {
  return text.replaceAll(/[^a-zA-Z0-9\s]+/g, '');
}

// export const freezePeriod = (data) => {
//   if (!data) {
//     return 'pairingPackage.noData';
//   }
//   const d = easternTime().getTime();
//   const pairingPosted = easternTime(data.pairingPostedOn).getTime();
//   const pairingFreeze = easternTime(data.pairingFreezedOn).getTime();
//   const biddingClosedOn = easternTime(new Date(`${data.biddingClosedOn} ${data.blockCloseTime}`)).getTime();
//   if (d < pairingPosted) {
//     return 'pairingPackage.statusAwaitingPosted';
//   }
//   if (d >= pairingPosted && d < pairingFreeze) {
//     return 'pairingPackage.statusPairingPosted';
//   } else if (d >= pairingFreeze && d < biddingClosedOn) {
//     return 'pairingPackage.stautsPairingFreeze';
//   } else if (d >= biddingClosedOn) {
//     return 'pairingPackage.stautsBiddingClosed';
//   }
// };

export const capitalizeFirstLetter = (word) => {
  if (!word) {
    return word;
  }
  return word.charAt(0).toUpperCase() + word.slice(1);
};

export const getDefaultActiveMenu = (pathName: string) => {
  if (pathName === '/') {
    return '';
  }
  const activeItems = menuItems.filter(
    (menu) =>
      menu.subItems.filter((subMenu) => subMenu.path === pathName).length
  );
  const menuItem = activeItems.length ? activeItems[0].id : '';
  return menuItem ? menuItem : pathName.replace('/', '');
};

export const getScreenSize = () => {
  if (window.screen.width >= 1025) {
    return 'large';
  } else if (window.screen.width >= 767 && window.screen.width < 1025) {
    return 'medium';
  } else return 'small';
};

export const getBuildDate = () => {
  const buildDate = preval`module.exports = new Date().toLocaleString();`;
  return formatDate(buildDate);
};

export const capitalizeFirstLetterWord = (word) => {
  if (!word) {
    return word;
  }
  const arr = word.split(' ');
  for (var i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }
  return arr.join(' ');
};
